import React from 'react'

import { PieChart, Pie, ResponsiveContainer, Tooltip, TooltipProps } from 'recharts';

import { IChartData, IChartProps } from '../../../interfaces/charts'
import { NameType, ValueType } from 'recharts/types/component/DefaultTooltipContent';


const PieChartComponent = (props: IChartProps) => {
    const { xLabel, data, width, height, color } = props;

    const generateColors = (count: number): string[] => {
        const colors: string[] = [];
        const saturation = 85; // Increased for more vibrant colors
        const lightness = 55;  // Adjusted for richer tones
        for (let i = 0; i < count; i++) {
            const hue = Math.floor((360 / count) * i);
            colors.push(`hsl(${hue}, ${saturation}%, ${lightness}%)`);
        }
        return colors;
    };

    const colorPalette = generateColors(data.length);
    const enrichedData = data.map((item, idx) => ({
        ...item,
        fill: color === 'auto' ? colorPalette[idx] : item.fill
    }));

    const labels = data.map((item: IChartData) => item.name);

    return (
        <div className='immersion__chart_container'>
            <div className='immersion__chart_container__label__X'>
                <h5 className='immersion__chart_container__label__X__text'>{xLabel}</h5>
            </div>

            <div className='immersion__chart_container__pie_chart'>
                <ResponsiveContainer width={width} height={height}>
                    <PieChart>
                        <Pie
                            nameKey="name"
                            cx="50%"
                            cy="50%"
                            outerRadius={150}
                            labelLine={false}
                            data={enrichedData}
                            dataKey="value"
                            activeIndex={-1}
                            isAnimationActive={false}
                        />
                        <Tooltip />
                    </PieChart>
                </ResponsiveContainer>
                <div className='immersion__chart_container__pie_chart__legend'>
                    {labels.map((label: string, idx: number) => (
                        <div className='immersion__chart_container__pie_chart__legend__item' key={idx}>
                            <div className='immersion__chart_container__pie_chart__legend__item__color' style={{ backgroundColor: enrichedData[idx].fill }} />
                            <p className='immersion__chart_container__pie_chart__legend__item__text'>{label}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default PieChartComponent